/**
 * The email a link asks the login box to start with: `/login?email=<address>`.
 *
 * Emails we send (the Vendoo welcome, first) link here so the seller signs in with the
 * address their account uses. Signing in with a phone or another email makes a second,
 * empty account, which is how most of the duplicate-seller list was made.
 *
 * Read from `location.search`, not the router: /login is statically rendered, so the
 * router's query is empty until hydration, and the login init runs once on mount.
 * Anything that is not a plausible email is ignored, so a mangled link falls back to
 * whatever the box would have shown anyway.
 */

import { isValidEmail } from '../../utils/email-verification';

export function emailFromSearch(search: string): string | null {
  const value = new URLSearchParams(search).get('email')?.trim();
  if (!value || value.length > 254) return null;
  return isValidEmail(value) ? value : null;
}
